<div class="flex items-center">
    <div class="toggler mr-8 flex items-center">
        <input [id]="inputId" [formControl]="control()" type="checkbox" />
    </div>
    <label class="cursor-pointer" [for]="inputId">{{ label() }}</label>
</div>
